<template>
  <div>
    <c-row>
      <c-col col="6">
        <c-card>
          <c-card-header>
            <c-card-title>
              <strong>Data Asal [Sebelum di rubah]</strong>
            </c-card-title>
          </c-card-header>
          <c-card-body>
            <table class="table table-bordered">
              <thead>
                <th>No</th>
                <th>Kode</th>
                <th>Nama</th>
                <th>Harga</th>
              </thead>
              <tbody>
                <tr v-for="(d, k) in original.sale_details" :key="k">
                  <td>{{k+1}}</td>
                  <td>{{d.warranty.warranty}}</td>
                  <td>{{d.item.name}}</td>
                  <td align="right">{{d.price | thousandSeparator}}</td>
                </tr>
                <tr class="bold">
                  <td colspan="3">{{original.terbilang}}</td>
                  <td>{{original.total | thousandSeparator}}</td>
                </tr>
              </tbody>
            </table>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col col="6">
        <c-card>
          <c-card-header>
            <c-card-title>
              <strong>Data Baru [Setelah di rubah]</strong>
            </c-card-title>
          </c-card-header>
          <c-card-body>
            <table class="table table-bordered">
              <thead>
                <th>No</th>
                <th>Kode</th>
                <th>Nama</th>
                <th>Harga</th>
              </thead>
              <tbody>
                <tr v-for="(d, k) in newData.sale_details" :key="k">
                  <td>{{k+1}}</td>
                  <td>{{d.warranty.warranty}}</td>
                  <td>{{d.item.name}}</td>
                  <td align="right">{{d.price | thousandSeparator}}</td>
                </tr>
                <tr class="bold">
                  <td colspan="3">{{newData.terbilang}}</td>
                  <td>{{newData.total | thousandSeparator}}</td>
                </tr>
              </tbody>
            </table>
            <div style="padding-top: 10px">
              <span class="bold">Alasan Edit:</span>
              <br />
              <span>{{newData.edit_reason}}</span>
            </div>
          </c-card-body>
          <c-card-footer v-if="newData.status == 3">
            <button class="btn btn-success" @click="approve">
              <i class="cil-check"></i> Approve
            </button>
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
export default {
  name: "Preview",
  data() {
    return {
      original: {},
      newData: {}
    };
  },
  created() {
    const params = this.$route.params;
    this.get(params.id);
  },
  methods: {
    get(id) {
      HTTPAUTH.get("/api/v1/sale/" + id).then(res => {
        this.newData = res.data.data;
        if (!this.newData.original) {
          this.$toasted.error("Data tidak bisa dibandingkan").goAway(2000);
          setTimeout(this.goBack, 500);
          return;
        }
        this.original = this.newData.original;
      });
    },
    approve() {
      const params = this.$route.params;
      HTTPAUTH.put(`/api/v1/sale/${params.id}`)
        .then(res => {
          this.$toasted.success("Data telah disetujui").goAway(3000);
          setTimeout(this.goBack, 500);
        })
        .catch(eres => {
          this.$toasted.error(eres.response.data.user_message).goAway(3000);
        });
    },
    goBack() {
      this.$router.push({path: "/kasir/process"});
    }
  }
};
</script>